// extracted by mini-css-extract-plugin
export default {"button":"button_button__HzWwD","small":"button_small__2CIMw","large":"button_large__bxdo9"};